@if (visible | async) {
    <div class="cover-layer">
        <sew-loader></sew-loader>
    </div>
}
